/** Formatea una fecha ISO a es-CO legible (ej: "16 may 2026"). */
export function formatDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('es-CO', {
    // timeZone explicito: los timestamps del API son ISO completos (UTC).
    // Sin fijar la zona, el dia depende del navegador del operador y se corre
    // cuando el timestamp cae cerca de medianoche UTC visto desde otra zona.
    // Pinear a America/Bogota muestra siempre el dia en hora colombiana.
    timeZone: 'America/Bogota',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}
